/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Transcript_Please_WaitInputs */



/**
* | output |
* | --- |
* | "Loading transcript... please wait..." |
*
* @param {Loading_Transcript_Please_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const loading_transcript_please_wait = /** @type {((inputs?: Loading_Transcript_Please_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Transcript_Please_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de la transcription... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkript wird geladen... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento della trascrizione... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка текста... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando transcripción... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载文字稿……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトを読み込んでいます...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रांसक्रिप्ट लोड हो रहा है... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando transcrição... aguarde...")
	return /** @type {LocalizedString} */ ("Loading transcript... please wait...")
});